query ApprovalMap($entityId: UUID!, $orderBy: [ApprovalMapTypesOrderBy!]) {
  approvalMap(entityApprovalId: $entityId, orderBy: $orderBy) {
    nodes {
      id
      appId
      approvalType
      digitalSignature
      isApproval
      messageUserId
      isApproved
      isBranch
      entityApprovalId
      isErrorFound
      isPending
      isRejected
      isRevoked
      isTree
      level
      messageUserId
      name
      parentId
      subTopic
      topic
      requestedDate
      statusDate
      status
      _accountingStampDate
      _accountingStampTransactionReference
      _accountingStampUserId
      _accountingStampUserName
      _isAccountingEntryStampedComplete
      _isTransactionCancelled
    }
  }
}
